import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import "./OfferCard.scss";

const OfferCard = ({ offer, canApply, handleOfferClick, selectedOfferId, onApply, appliedCouponCode, error }) => {
  return (
    <div
      className={cx("offerCard", {
        selectedOffer: selectedOfferId === offer.id,
      })}
      onClick={() => handleOfferClick(offer.id)}
    >
      <div className="couponDetails">
        <div className="couponDetailsLeft">
          <img alt="offer" src={offer.image} />
          {offer.expiry && !!offer.expiry.expiryText && (
            <div className="expiryText">Expiring in 9 days</div>
          )}
        </div>
        <div className="couponDetailsRight">
          <p className="title">{offer.title || "N/A"}</p>
          <p className="shortDescription" title={offer.shortDescription}>
            {offer.shortDescription || "N/A"}
          </p>
        </div>
      </div>
      <div className="couponMeta">
        <div>
          {!offer.isExpired ? (
            offer.promoCode ? (
              <span>
                Code: <strong className="code">{offer.promoCode}</strong>
              </span>
            ) : (
              "No Code Required"
            )
          ) : (
            "Offer Expired"
          )}
        </div>
        {!!error && <span className="errorText">{error}</span>}
        {
          !error && (appliedCouponCode === offer.promoCode ? <div className="applied">Applied</div> : canApply && offer.promoCode && !offer.isExpired && <div className="applyBtn" onClick={onApply}>APPLY</div>)
        }
      </div>
    </div>
  );
};

OfferCard.propTypes = {
  offer: PropTypes.object.isRequired,
  canApply: PropTypes.bool.isRequired,
  handleOfferClick: PropTypes.func.isRequired,
  selectedOfferId: PropTypes.number,
  onApply: PropTypes.func.isRequired,
  appliedCouponCode: PropTypes.string,
  error: PropTypes.string
};

OfferCard.defaultProps = {
  selectedOfferId: null,
  appliedCouponCode: '',
  error: '',
};

export default OfferCard;
